export default __webpack_public_path__ + "static/media/bodynew.a489963c.gif";